import { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { AdminAuthProvider, useAdminAuth } from "@/lib/adminAuth";
import { Sparkles, Shield } from "lucide-react";
import { toast } from "sonner";
import GoogleButton from "@/components/GoogleButton";

function LoginInner() {
  const { admin, loading, devLogin, adminGoogleLogin } = useAdminAuth();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);
  const nav = useNavigate();
  const location = useLocation();

  useEffect(() => {
    if (admin && !loading) nav("/admin/dashboard");
  }, [admin, loading, nav]);

  const onGoogle = async (credential) => {
    try {
      await adminGoogleLogin(credential);
      toast.success("Admin girişi başarılı");
      nav("/admin/dashboard");
    } catch (err) {
      toast.error(err.response?.data?.detail || "Google girişi başarısız");
    }
  };

  const doDev = async () => {
    setBusy(true);
    try {
      await devLogin(email, password);
      toast.success("Admin girişi başarılı");
      nav("/admin/dashboard");
    } catch (err) {
      toast.error(err.response?.data?.detail || "Giriş başarısız");
    } finally { setBusy(false); }
  };

  return (
    <div className="admin-bg min-h-screen flex items-center justify-center px-4">
      <div className="w-full max-w-md">
        <div className="flex items-center gap-2 justify-center mb-8">
          <Sparkles className="w-6 h-6 text-[#F59E0B]" />
          <span className="font-admin-head text-2xl">FalZilla Admin</span>
        </div>
        <div className="admin-card p-8">
          <div className="flex items-center gap-2 mb-2">
            <Shield className="w-5 h-5 text-[#F59E0B]" />
            <h1 className="font-admin-head text-2xl">Yönetici Girişi</h1>
          </div>
          <p className="text-sm text-white/50 mb-6 font-admin-body">Sadece whitelist'teki e-postalar giriş yapabilir.</p>

          <GoogleButton onCredential={onGoogle} text="signin_with" />

          <div className="text-center text-xs text-white/40 my-4 font-admin-body">— veya —</div>

          <div className="space-y-3">
            <input
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              data-testid="admin-dev-email"
              className="admin-input"
              placeholder="E-posta"
            />
            <input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              onKeyDown={(e) => e.key === "Enter" && doDev()}
              data-testid="admin-password"
              className="admin-input"
              placeholder="Şifre"
            />
            <button onClick={doDev} disabled={busy} data-testid="admin-dev-login-btn" className="admin-btn-ghost w-full py-2.5 font-admin-body">
              {busy ? "Giriş yapılıyor..." : "Giriş Yap"}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default function AdminLogin() {
  return (
    <AdminAuthProvider>
      <LoginInner />
    </AdminAuthProvider>
  );
}
